import { useState } from 'react';
import { ROUTES } from "../App";
import { get, ref } from "firebase/database";
import { database, functions } from "../constants/firebase";
import { httpsCallable } from "firebase/functions";
import useMoveTo from '../constants/navigation';

const ForgotPassword = () => {
    const navigate = useMoveTo();
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setIsSubmitting(true);

        try {
            // Check if email exists in Users node
            const snapshot = await get(ref(database, 'Users'));
            let emailExists = false;

            snapshot.forEach(child => {
                const data = child.val();
                if (data.email === email) {
                    emailExists = true;
                }
            });

            if (!emailExists) {
                setError("No account found with this email.");
            } else {
                // Call the Cloud Function instead of Firebase's default method
                const sendCustomResetEmail = httpsCallable(functions, 'sendCustomPasswordReset');
                await sendCustomResetEmail({ email });
                setSuccess("Check your inbox (or spam folder) for a password reset link. If found in spam, mark it as 'Not Spam' to ensure future delivery.");
            }
        } catch (err) {
            console.error("Reset error:", err.message);
            setError(err.message || "Something went wrong. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="bg-main w-full flex items-center justify-center px-4 sm:px-6 md:px-8 py-12">
            <div className="w-full max-w-md mt-20">
                {/* Header */}
                <div className="text-center mb-8">
                    <h3 className="text-2xl md:text-4xl font-bold dark:text-white mb-2 text-black">
                        Forgotten Password
                    </h3>
                    <p className="text-sm md:text-base dark:text-gray-300 text-gray-700">
                        Enter your registered email and we'll send you a link to reset your password.
                    </p>
                    {error && <p className="text-red-500 text-sm mt-3">{error}</p>}
                    {success && <p className="text-green-500 text-sm mt-3">{success}</p>}
                </div>

                {/* Form */}
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="email" className="sr-only">Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Email"
                            className="w-full rounded-xl px-4 py-3 outline-none placeholder:text-[#7C8BA0] 
               bg-[#F5F9FE] dark:bg-white 
               text-black dark:text-black
               border border-gray-200 dark:border-0"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="btn-primary w-full"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Please wait...' : 'Send Reset Link'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;